import Vue from 'vue';
import router from '@/router';
import store from '@/store';
import i18n from 'common-module/src/lang';
import config from 'common-module/src/config';
import { useRouterFilter } from '@zk/framework-vue';

const filterFiles = require.context('@/router/filter', true, /\.(j|t)s/);
const filterClass = filterFiles.keys().map(key => filterFiles(key)[Object.keys(filterFiles(key))[0]]);
useRouterFilter(Vue, {
  router,
  filterFiles: [...filterClass],
  filterOption: {
    store,
    i18n,
    showLog: !['prod', 'pre'].includes(config.VUE_APP_ENV)
  }
});

router.beforeEach(((to, from, next) => {
  console.log(`from: ${from.fullPath} ===> to: ${to.fullPath}`);
  next();
}));
